import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment'
import { sign, UUID } from 'crypto';
import { KeycloakAuthService } from '../keycloak-auth.service';


@Component({
  selector: 'app-administrator-header',
  templateUrl: './administrator-header.component.html',
  styleUrls: ['./administrator-header.component.css']
})
  export class AdministratorHeaderComponent implements OnInit {

    constructor(
      private router: Router,
      public authService: AuthService,
      private keycloakAuth: KeycloakAuthService
    ) { }

    keycloakId: any;
    adminUsername: string;
    isSigned: boolean;
    epimelitirio: string;
    ngOnInit() {
      this.authService.isAdminAuthenticated$.subscribe((res) => {
        this.epimelitirio = environment.environment;
        this.isSigned = res;
        if (this.isSigned) {
          this.keycloakId = this.authService.getSessionUser().keycloakId;
          this.adminUsername = this.authService.getSessionUser().username;
        } else {
          if (sessionStorage.getItem("user")) {
            this.authService.clearSessionUser();
            this.keycloakAuth.logout(window.location.origin + '/', true);
          }
        }
      }
      )
    };

    signout() {
      this.authService.clearSessionUser();
      this.keycloakAuth.logout(window.location.origin + '/', true);
      this.router.navigate(['/home']);
    }

    candidatesHandling(keycloakId: UUID) {
      this.router.navigate(['administrator/cvHandling', keycloakId]);
    }

  }
